export default {
    path: '/',
    component: () => import('@/views/shop/Index'),
    children: [
        {
            name: 'scan',
            path: '',
            component: () => import('@/views/shop/Scan'),
            meta: {
                requiresAuth: true,
                coolrunnerOnly: false,

            },
        },
        {
            name: 'list',
            path: 'list',
            component: () => import('@/views/shop/List'),
            meta: {
                requiresAuth: true,
                coolrunnerOnly: false,

            },
        },
    ],
}
